import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import Link from '../../src/components/app/link';

declare module '@mui/material/styles' {
  interface Palette {
    pistachio: Palette['primary'];
    sky: Palette['primary'];
  }

  interface PaletteOptions {
    pistachio?: PaletteOptions['primary'];
    sky?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    pistachio: true;
    sky: true;
  }
}

declare module '@mui/material/styles' {
  interface PaletteColor {
    title?: string;
  }

  interface SimplePaletteColorOptions {
    title?: string;
  }
}

const themeBase = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#8D5C87',
      dark: '#7A4C7A',
      light: '#B99BB5',
    },
    secondary: {
      main: '#FFCC33',
      dark: '#FFBB33',
      light: '#FFDE83',
    },
    background: {
      default: '#F8F6F280',
    },
    info: {
      main: '#3187BF',
      dark: '#007CBA',
      light: '#81B5D7',
    },
    pistachio: {
      main: '#A7CDBD',
      dark: '#8FBFA8',
      light: '#C8DFD5',
      title: '#305F6D',
    },
    sky: {
      main: '#96D1F3',
      dark: '#3187bf',
      light: '#D3EBF8',
      title: '#007CBA',
    },
    grey: {
      600: '#00000060',
      900: '#00000099',
    },
  },
  typography: {
    fontFamily: 'Inter',
    h1: { fontFamily: 'Domine' },
    h2: { fontFamily: 'Domine' },
    h3: { fontFamily: 'Domine' },
    h4: { fontFamily: 'Domine' },
    h5: { fontFamily: 'Domine' },
    h6: { fontFamily: 'Domine' },
    subtitle1: { fontFamily: 'Domine', fontWeight: 600 },
    subtitle2: { fontFamily: 'Domine' },
    button: { textTransform: 'none' },
  },
  shape: {
    borderRadius: 12, // Increase default border radius
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: Link,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          paddingLeft: 16,
          paddingRight: 16,
          borderRadius: 24, // Fully round buttons
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'subtitle1' },
      },
    },
    MuiStack: {
      defaultProps: {
        useFlexGap: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'rgba(0,0,0,0.6)',
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 700, // default was set to 600
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export const theme = responsiveFontSizes(themeBase);
